<template>
    <el-dialog  append-to-body  :title="title" :visible.sync="dialogFormVisible" @close="close"
               :close-on-click-modal="false" :close-on-press-escape="false" width="980px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="试卷标题" prop="title">
                <el-input v-model="form.title" placeholder="试卷标题" clearable/>
            </el-form-item>
            <el-form-item label="学习积分" prop="study_point">
                <el-input type="number" min="0" v-model="form.study_point" placeholder="学习积分" clearable/>
            </el-form-item>

            <el-form-item label="课程" prop="course">
                <el-button type="primary" icon="el-icon-plus" @click="handelSelectCourse">选择课程</el-button>
                <el-row>
                    <span style="font-size: 16px">{{ course.title ? '已选择：'+course.title : '请选择课程' }}</span>
                </el-row>
            </el-form-item>

            <el-form-item label="题目" prop="question">
                <el-button type="primary" icon="el-icon-plus" @click="handelSelectQuestion">添加试题</el-button>
                <el-button type="success" icon="el-icon-sort" @click="handelQuestionSort">排序重置</el-button>
            </el-form-item>

            <el-form-item label="已选择的题目" prop="question">
                <draggable :list="questions" class="question-list" :group="{ name: 'people', pull: 'clone', put: false }" @end="dropList" :animation="500" handle =".question-item-sort" } >
                    <div class="question-item" v-for="(item, index) in questions" :key="index">
                        <div class="question-item-title"> <span style="color: #00a0e9"> [{{item.question_type_desc}}] </span> {{item.title}} </div>
                        <div class="question-item-serial">
                            <el-input type="text" v-model.number="questions[index].score" placeholder="分数" />
                        </div>
                        <div class="question-item-serial">
                            <el-input type="text" :min="1" v-model.number="questions[index].sort" placeholder="排序" disabled />
                        </div>
                        <div class="question-item-remove">
                            <el-button type="danger" icon="el-icon-delete" @click="removeQuestion(item)"></el-button>
                        </div>
                        <div class="question-item-sort">
                            <el-button type="success" icon="el-icon-sort"></el-button>
                        </div>
                    </div>
                </draggable>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" type="textarea" placeholder="备注" clearable/>
            </el-form-item>

<!--            <el-form-item label="封面" prop="image_id">-->
<!--                <el-row>-->
<!--                    <el-button type="primary" @click="openUpload">选择图片</el-button>-->
<!--                    <div v-if="form.image_id !== ''" class="img">-->
<!--                        <img :src="file_path" width="100" height="100" />-->
<!--                    </div>-->
<!--                </el-row>-->
<!--            </el-form-item>-->

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
<!--        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>-->
        <question-list-dialog ref="question" @fetch-data="questionData"></question-list-dialog>
        <course-list-dialog ref="course" :course_num="1" @fetch-data="courseData"></course-list-dialog>
    </el-dialog>
</template>

<script>
    import { examEdit, examDetail } from '@/api/education';
    // import Upload from '@/components/file/Upload';
    import draggable from 'vuedraggable';
    import questionListDialog from '../../components/question-list'
    import courseListDialog from '../../components/course-list'

    export default {
        components: {
            // Upload,
            draggable,
            questionListDialog,
            courseListDialog
        },
        data() {
            return {
                title: '',
                form: {
                    exam_id: '',
                    image_id: '',
                    title: '',
                    study_point:'',
                    remark: '',
                    sort: 0,
                    course_id: '',
                    questions: [],
                    status: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],
                    study_point: [{
                        required: true,
                        message: '请输入学习积分',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,

                // 选择的试题
                questions: [],
                // 选择的课程
                course: {
                    title: '',
                }

            };
        },
        props: ['fetch-data'],
        created() {
            document.body.ondrop = function(event) {
                event.preventDefault()
                event.stopPropagation()
            }
        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加考试'
                } else {
                    this.title = '编辑考试'
                    this.form.exam_id = row.exam_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.questions = []
                this.course = []
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        this.form.questions = this.questions
                        examEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                examDetail({id: this.form.exam_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.questions = result.data.question
                    if(result.data.course){
                        this.course = result.data.course
                    }
                    //this.course = result.data.course
                    // this.file_path = result.data.file_path
                })
            },

            // 选择课程
            handelSelectCourse(){
                this.$refs['course'].showDialog()
            },
            courseData(val){
                if(val.length > 0){
                    this.course = val[0]
                    this.form.course_id = val[0].course_id
                }
            },

            //  选择试题
            handelSelectQuestion(){
                this.$refs['question'].showDialog()
            },
            // 选择的试题
            questionData(val){
                let find_count = 0
                val.map((item, index)=>{
                    this.questions.map((item2, index2)=>{
                        if(item.question_id === item2.question_id){
                            find_count++
                            this.questions.splice(index2, 1)
                        }
                    })
                    this.questions.push(item)
                })
                if(find_count > 0){
                    this.$message({ type: 'info', message: `有${find_count}个相同试题已替换` })
                }
                this.handelQuestionSort()
            },
            dropList(ev){
                this.handelQuestionSort()
            },
            // 移除试题
            removeQuestion(row){
                this.questions.map((item, index)=>{
                    if(item.question_id === row.question_id){
                        this.questions.splice(index, 1)
                    }
                })
                this.handelQuestionSort()
            },
            // 对当前选中的试题重新排序
            handelQuestionSort(){
                if(this.questions.length === 0){
                    this.$message({ type: 'error', message: '请先添加试题' })
                    return
                }
                this.questions.map((item, index)=>{
                    this.questions[index].sort = index + 1
                })
                this.$forceUpdate();
            },

            // 图片上传
            openUpload(e) {
                this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    this.file_path = e[0].file_path;
                    this.form.image_id = e[0].file_id;
                }
                this.isupload = false;
            },

        }
    };
</script>

<style scoped>
    .question-item{
        display: flex;
        flex-direction: row;
        margin: 3px 0;
    }
    .question-item-title{
        width: 550px;
    }
    .question-item-serial{
        width: 80px;
        margin: 0 5px;
    }
    .question-item-remove{
        width: 60px;
    }
    .question-item-sort{
        width: 80px;
    }
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/exam/exam/edit.vue